import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

/** @namespace Bodypwa/Component/ScrollSwiperSlide/Component/ScrollSwiperSlide */
export const ScrollSwiperSlide = ({ children, widthClass = '', swiperClass = 'swiper-slide', isActive = false }) => {
    const sliderRef = useRef(null);

    useEffect(() => {
        smoothscroll.polyfill();
    }, []);

    useEffect(() => {
        if (isActive && sliderRef.current) {
            const container = sliderRef.current.parentElement;
            if (container) {
                const slide = sliderRef.current;
                const centeredLeft = slide.offsetLeft - (container.clientWidth / 2) + (slide.offsetWidth / 2);
                container.scrollTo({
                    left: centeredLeft,
                    behavior: 'smooth'
                });
            }
        }
    }, [isActive]);

    return (
        <div
            className={ ` shrink-0 w-full h-full relative transition-transform ${swiperClass} ${widthClass}` }
            ref={ sliderRef }
        >
            { children }
        </div>
    );
};

ScrollSwiperSlide.propTypes = {
    children: PropTypes.node.isRequired,
    widthClass: PropTypes.string,
    swiperClass: PropTypes.string,
    isActive: PropTypes.bool
};

export default ScrollSwiperSlide;
